module.exports = __webpack_public_path__ + "img/close.f52e788e.svg";